import isSmimeAdapterUsable from 'owa-smime-adapter/lib/utils/isSmimeAdapterUsable';
import isSmimeDecoded from './isSmimeDecoded';
import { lazySmimeAdapter } from 'owa-smime-adapter';
import { ClientItem } from 'owa-mail-store';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';

/**
 * This utils tells whether an S/MIME item is in decoding state or not.
 * S/MIME item is in decoding state when S/MIME adapter is usable
 * and S/MIME is not decoded yet and there is no error.
 */
const isSmimeItemDecoding = (item: ClientItem): Promise<boolean> => {
    return lazySmimeAdapter.import().then(() => {
        return (
            isSmimeAdapterUsable() &&
            (!item.Smime ||
                (!isSmimeDecoded(item) && item.Smime.ErrorState == SmimeErrorStateEnum.NoError))
        );
    });
};

export default isSmimeItemDecoding;
